<template>
  <v-row justify="start">
    <v-col cols="12" sm="12" md="2" v-for="(item, i) in items" :key="i">
      <v-list-item>
        <v-card class="card-border">
          <v-card-text>
            <v-icon class="icon" x-large>mdi-{{ item.tipoMidia }}</v-icon>
            <v-btn class="link" elevation="1" small text :href="item.shortLink" target="_blank">{{ item.shortLink }}</v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="ma-3 pl-5 pr-5"
              outlined
              color="#f77066"
              small
              dark
              rounded
              depressed
              @click="copyClipboard(item)"
              >Copiar Link</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-list-item>
    </v-col>
    <v-snackbar v-model="snackbar" color="success" :timeout="3000" :top="true">
      <span>Link copiado</span>
      <v-btn text @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import LinkForm from "@/services/linkForm";

export default {
  name: "GerarLink",

  data() {
    return {
      items: [],
      serviceLinkForm: new LinkForm(),
      snackbar: false,
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"]),
  },

  methods: {
    copyClipboard(item) {
      let element = document.createElement("input");
      document.body.appendChild(element);
      element.value = item.shortLink;
      element.select();
      document.execCommand("copy");
      document.body.removeChild(element);
      this.snackbar = true;
    },
  },

  async mounted() {
    try {
      const response = await this.serviceLinkForm.create(this.getUser.cpf);
      this.items = response
      return Promise.resolve();
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
  },
};
</script>

<style scoped>
.link {
  text-transform: none;
  width: 80%;
}

.icon {
  width: 20%;
}
</style>
